var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgShare = function SvgShare(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4L14.58 5.42L12.99 3.83V15H11.01V3.83L9.42 5.42L8 4L12 0L16 4ZM20 9V20C20 21.1 19.1 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V9C4 7.89 4.89 7 6 7H9V9H6V20H18V9H15V7H18C18.5304 7 19.0391 7.21071 19.4142 7.58579C19.7893 7.96086 20 8.46957 20 9Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDRMMTQuNTggNS40MkwxMi45OSAzLjgzVjE1SDExLjAxVjMuODNMOS40MiA1LjQyTDggNEwxMiAwTDE2IDRaTTIwIDlWMjBDMjAgMjEuMSAxOS4xIDIyIDE4IDIySDZDNS40Njk1NyAyMiA0Ljk2MDg2IDIxLjc4OTMgNC41ODU3OSAyMS40MTQyQzQuMjEwNzEgMjEuMDM5MSA0IDIwLjUzMDQgNCAyMFY5QzQgNy44OSA0Ljg5IDcgNiA3SDlWOUg2VjIwSDE4VjlIMTVWN0gxOEMxOC41MzA0IDcgMTkuMDM5MSA3LjIxMDcxIDE5LjQxNDIgNy41ODU3OUMxOS43ODkzIDcuOTYwODYgMjAgOC40Njk1NyAyMCA5WiIgZmlsbD0iIzMzMzMzMyIvPgo8L3N2Zz4K";